if (!customElements.get('gt-collection-card-buy')) {
  customElements.define('gt-collection-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.card = this.closest('.product-card-wrapper');
      this.price = this.card?.querySelector('[data-gt-card-price]');
      this.badge = this.card?.querySelector('[data-gt-card-badge]');
      if (!this.form || !this.button) return;
      this.addLabel = window.variantStrings.addToCart;
      this.soldOutLabel = window.variantStrings.soldOut;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]') || this.locked) return;
        this.selectVariant(event.target);
      }, {signal: this.controller.signal});
      this.form.addEventListener('submit', () => {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        this.locked = true;
        this.radios.forEach((input) => { input.disabled = true; });
      }, {capture: true, signal: this.controller.signal});
      this.observer = new MutationObserver(() => {
        if (this.locked && !this.button.classList.contains('loading')) {
          this.locked = false;
          this.radios.forEach((input) => { input.disabled = false; });
        }
      });
      this.observer.observe(this.button, {attributes: true, attributeFilter: ['class']});
    }

    selectVariant(input) {
      const available = input.dataset.available === 'true';
      this.form.querySelector('[name="id"]').value = input.value;
      this.form.querySelector('[name="quantity"]').value = input.dataset.quantity || '1';
      this.button.disabled = !available;
      this.button.removeAttribute('aria-disabled');
      const label = this.button.querySelector('.gt-collection-buy__label');
      label.textContent = available ? this.addLabel : this.soldOutLabel;
      label.classList.remove('hidden');
      this.button.querySelector('.sold-out-message')?.classList.add('hidden');
      const error = this.querySelector('.product-form__error-message-wrapper');
      if (error) error.hidden = true;
      const price = [...this.querySelectorAll('template[data-variant-price]')].find((node) => node.dataset.variantPrice === input.value);
      if (price && this.price) this.price.replaceChildren(price.content.cloneNode(true));
      if (this.badge) {
        const currentPrice = Number(input.dataset.price);
        const comparePrice = Number(input.dataset.comparePrice);
        const discounted = available && comparePrice > currentPrice && comparePrice > 0;
        this.badge.hidden = available && !discounted;
        this.badge.dataset.state = !available ? 'sold-out' : discounted ? 'sale' : 'none';
        this.badge.textContent = !available ? this.soldOutLabel : discounted
          ? this.dataset.discountLabel.replace('[percent]', Math.round((comparePrice - currentPrice) * 100 / comparePrice))
          : '';
      }
      this.card?.querySelectorAll('.card__heading a.full-unstyled-link').forEach((link) => {
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('variant', input.value);
        link.href = url.href;
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}


if (!customElements.get('gt-carousel-progress')) {
  customElements.define('gt-carousel-progress', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.closest('slider-component')?.querySelector('.slider--tablet');
      if (!this.slider) return;
      this.dots = [...this.querySelectorAll('.gt-carousel-progress__dots span')];
      this.update = () => {
        const max = this.slider.scrollWidth - this.slider.clientWidth;
        this.hidden = max <= 2;
        if (this.hidden) return;
        const position = Math.max(0, Math.min(1, Math.abs(this.slider.scrollLeft) / max));
        const active = Math.round(position * (this.dots.length - 1));
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === active);
          dot.classList.toggle('is-near', Math.abs(index - active) === 1);
        });
      };
      this.slider.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.slider);
      this.update();
    }
    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }
  });
}


if (!customElements.get('gt-product-recommendations-mount')) {
  customElements.define('gt-product-recommendations-mount', class extends HTMLElement {
    connectedCallback() {
      const parent = this.parentElement;
      if (!parent) return;
      const place = () => {
        const app = parent.querySelector(':scope > .lb-widget-cpac');
        if (app && this.nextElementSibling !== app) parent.insertBefore(this, app);
      };
      this.placementObserver = new MutationObserver(place);
      this.placementObserver.observe(parent, { childList: true });
      place();
    }
    disconnectedCallback() { this.placementObserver?.disconnect(); }
  });
}
